// extracted by mini-css-extract-plugin
module.exports = {"frame":"frame_frame__38XhW","scrollbar":"frame_scrollbar__nBX7p","grayScrollbar":"frame_grayScrollbar__WqZEd","fade":"frame_fade__2x60_"};